import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import Genre from '@/components/screens/genre/Genre';
import { BOOKS_FOR_PAGE, API_URL } from '@/helpers/variables';
import { IGenreBooksPage } from '@/interfaces/genreBooksPage.interface';
import { IGenre } from '@/interfaces/genre.interface';

interface IGenrePageDynamicProps {
  books: IGenreBooksPage;
  genres: IGenre;
  freeBooks: boolean;
}

const GenrePageDynamic: NextPage<IGenrePageDynamicProps> = ({ books, genres, freeBooks }) => {
  return <Genre books={books} freeBooks={freeBooks} genres={genres} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { alias, free_books, page } = context.query;

  const booksRes = await fetch(`${API_URL}genres/books/${alias}?${!!free_books ? `free_book=true&` : ``}page=${page ? page : `1`}&page_size=${BOOKS_FOR_PAGE}`);
  const books = await booksRes.json();

  const genresRes = await fetch(`${API_URL}satellite/genres/genre/${alias}`);
  const genres = await genresRes.json();

  if (booksRes.status === 404) {
    const redirectUrl = books.detail?.url;

    if (redirectUrl) {
      return {
        redirect: {
          destination: redirectUrl,
          permanent: true,
        },
      };
    }
  }

  if (!booksRes.ok) {
    console.table(`Error ${booksRes.status}. Api: ${booksRes.url}`);
    return {
      notFound: true,
    };
  }

  if (!books.books) {
    return {
      notFound: true,
    };
  }

  const freeBooks = !!free_books;

  return { props: { books, freeBooks, genres } };
};

export default GenrePageDynamic;
